/* eslint-disable no-unused-vars */
import React, { useState, useMemo } from 'react';
// eslint-disable-next-line no-unused-vars
import styled from 'styled-components/macro';
import { format } from 'date-fns';
import DataLayout from '../components/molecules/DataLayout';
import FiltersJSX from '../components/organisms/FilterJSX';
import Pagination from '../components/molecules/Pagination';
import Table from '../components/molecules/Table';
import UserService from '../services/userService';
import { no_permission, getDateObject, convertToCurrencyFormat } from '../helpers/common';

const PaymentHistory = () => {
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeKey, setActiveKey] = useState('');
  const [searchQuery, setSearchQuery] = useState({
    searchText: '',
    sortBy: 'created_at',
    sortOrder: -1,
    page: 1,
    pageSize: 10,
    filterText: '',
    startDate: '',
    endDate: '',
  });

  const { history_data } = UserService.GetPaymentHistory(searchQuery);

  const dummyData = [
    {
      created_at: '2022-01-01',
      amount: 100,
      reference_number: 'ABC123',
      type: 'Payment',
      previous_balance: 1000,
      active_balance: 900,
    },
    {
      created_at: '2022-01-01',
      amount: 100,
      reference_number: 'ABC123',
      type: 'Payment',
      previous_balance: 1000,
      active_balance: 900,
    },
    {
      created_at: '2022-01-01',
      amount: 100,
      reference_number: 'ABC123',
      type: 'Payment',
      previous_balance: 1000,
      active_balance: 900,
    },
    {
      created_at: '2022-01-01',
      amount: 100,
      reference_number: 'ABC123',
      type: 'Payment',
      previous_balance: 1000,
      active_balance: 900,
    },
    {
      created_at: '2022-01-01',
      amount: 100,
      reference_number: 'ABC123',
      type: 'Payment',
      previous_balance: 1000,
      active_balance: 900,
    },
  ];

  const { payment_history, totalItems } = useMemo(
    () => ({
      payment_history: dummyData
        ?.map(item => [
          format(getDateObject(item.created_at), 'yyyy-MM-dd'),
          convertToCurrencyFormat(item.amount),
          item?.linking_id ? item?.linking_id : item.reference_number,
          item.type,
          convertToCurrencyFormat(item.previous_balance),
          convertToCurrencyFormat(item.active_balance),
        ])
        .reduce((prev, curr) => {
          prev.push(curr.filter(item => item !== no_permission));
          return prev;
        }, []),
      totalItems: history_data?.records?.totalItems,
    }),
    [history_data],
  );

  const columnNames = [
    { name: 'Date', sort: true, sortKey: 'created_at' },
    { name: 'Amount' },
    { name: 'Reference Number' },
    { name: 'Transaction Type' },
    { name: 'Previous Balance' },
    { name: 'Active Balance' },
  ];

  return (
    <DataLayout
      title="Payment History"
      filters={
        <FiltersJSX
          onFilterChange={({ searchText = '', sortOrder, sortBy, filterText, startDate, endDate }) => {
            setCurrentPage(() => 1);
            setSearchQuery(() => ({
              searchText,
              sortBy,
              sortOrder,
              filterText,
              startDate,
              endDate,
            }));
          }}
          setActiveKey={setActiveKey}
        />
      }>
      <Table
        loading={false}
        rowsData={payment_history}
        columnNames={columnNames}
        itemsPerPage={pageSize}
        onSort={(sortBy, sortOrder) => {
          setSearchQuery(_ => ({ ..._, sortBy, sortOrder }));
        }}
        setActiveKey={setActiveKey}
        activeKey={activeKey}
      />
      <Pagination
        className="pagination-bar"
        currentPage={currentPage}
        totalCount={totalItems ?? 0}
        pageSize={pageSize}
        onPageChange={page => {
          setCurrentPage(page);
        }}
        onPageSizeChange={e => setPageSize(e)}
      />
    </DataLayout>
  );
};

export default PaymentHistory;
